<template>
  <div class="row">
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 d-flex align-items-center"
    >
      <img
        :src="require('../../../../assets/capsules-solid.svg')"
        width="40"
        class="mb-2"
      />
      <div class="ml-2">
        <h6 class="mb-0">
          MEDICAMENTO:
          {{ medicine.name }}
        </h6>
        <h6 class="mb-0">
          UNIDADE DE ADMINISTRAÇÃO:
          {{ medicine.unit_of_measurement_abbreviation }}
        </h6>
      </div>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <hr />
      <h1 class="title-pages">ORIGEM</h1>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
      <LabelRequiredField label="GRUPO" />
      <select
        v-model="origin_stock_group_id"
        class="form-control"
        @change="getLots"
      >
        <option value="">SELECIONE...</option>
        <option v-for="stock in stock_groups" :key="stock.id" :value="stock.id">
          {{ stock.name }}
        </option>
      </select>
    </div>
    <div
      class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 pt-0 pb-0"
      v-if="stocked_item_lot.length == 0"
    >
      <LabelRequiredField label="LOTE" />
      <select disabled class="form-control">
        <option value="">NENHUM LOTE ENCONRADO!</option>
      </select>
    </div>
    <div
      v-if="stocked_item_lot.length > 0"
      class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 pt-0 pb-0"
    >
      <LabelRequiredField label="LOTE" />
      <select v-model="origin_stocked_item_id" class="form-control">
        <option value="">SELECIONE...</option>
        <option
          v-for="(lot, key) in stocked_item_lot"
          :key="key"
          :value="lot.stocked_item_id"
        >
          {{ lot.amount }} {{ medicine.unit_of_measurement_abbreviation }} /
          LOTE: {{ lot.lot }} / VENCIMENTO:
          {{ formatDateToMonthYear(lot.due_date) }}
        </option>
      </select>
    </div>
    <div class="mt-2 mb-2 col-md-12 text-center v-warning" v-if="lot_separate">
      <h6 class="m-0">
        EXISTE MEDICAMENTO SEPARADO DO LOTE DO ESTOQUE SELECIONADO, É PRECISO
        CHECAR OU NÃO SEPARAR O MEDICAMENTO PARA PODER REALIZAR A TRANSFERÊNCIA
        DO ESTOQUE!
      </h6>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
      <LabelRequiredField :label="medicine.unit_of_measurement_abbreviation" />
      <input
        :disabled="stocked_item_lot.length == 0"
        v-model="amount"
        type="number"
        class="form-control"
      />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <hr />
      <h1 class="title-pages">DESTINO</h1>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 pb-0">
      <p
        class="worksansr m-0 c-warning"
        v-if="
          destination_stock_group_id &&
          origin_stock_group_id &&
          destination_stock_group_id == origin_stock_group_id
        "
      >
        Não pode transferir para o mesmo grupo!
      </p>
      <LabelRequiredField label="GRUPO" />
      <select
        :disabled="stocked_item_lot.length == 0"
        v-model="destination_stock_group_id"
        class="form-control"
      >
        <option value="">SELECIONE...</option>
        <option v-for="stock in stock_groups" :key="stock.id" :value="stock.id">
          {{ stock.name }}
        </option>
      </select>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 d-flex justify-content-between">
      <v-btn @click="$bvModal.hide('transferMedicine')" class="btn-cancel"
        ><i class="fas fa-times mr-2 text-twenty"></i> CANCELAR</v-btn
      >
      <v-btn
        :disabled="
          loading ||
          !origin_stock_group_id ||
          stocked_item_lot.length == 0 ||
          !origin_stocked_item_id ||
          !amount ||
          !destination_stock_group_id ||
          destination_stock_group_id == origin_stock_group_id
        "
        @click="execute"
        class="btn-save"
        ><i class="mr-2 text-twenty fa fa-check"></i>
        {{ loading ? "CARREGANDO" : "TRANSFERIR" }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../Components/LabelRequiredField";

import api from "../../../../services/api";

import APIGet from "../../../../lib/api-get";

import toast from "../../../../lib/ToastNotification";

import { formatDateToMonthYear } from "../../../../lib/format";

export default {
  name: "TransferMedicine",

  components: {
    ErrorsMessages,
    LabelRequiredField,
  },

  props: {
    medicine: { type: Object, required: true },
    resident_id: { type: [String, Number], required: true },
  },

  data() {
    return {
      origin_stock_group_id: "",
      origin_stocked_item_id: "",
      amount: "",

      destination_stock_group_id: "",

      stock_groups: [],
      stocked_item_lot: [],
      lot_separate: false,

      errors: [],
      loading: false,
      loadingLots: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDateToMonthYear,

    async getLots() {
      try {
        this.origin_stocked_item_id = "";
        this.loadingLots = true;

        let { resident_id, origin_stock_group_id, medicine } = this;

        let params = {
          resident_id,
          stock_group_id: origin_stock_group_id,
          medicine_id: medicine.medicine_id,
        };

        const response = await api.get(
          "/rest-home/resident/stock/lots-by-stock-group",
          {
            params,
          }
        );

        const { stocked_item_lot, lot_separate } = response.data;

        this.stocked_item_lot = stocked_item_lot;
        this.lot_separate = lot_separate;

        this.loadingLots = false;
      } catch (error) {
        console.log(error);
      }
    },

    async retrieve() {
      await this.getStockGroups();
    },

    async getStockGroups() {
      this.loading = true;
      let params = { type: "MEDICINE" };
      const { error, errors, stock_groups } = await APIGet.getStockGroups(
        params
      );
      this.errors = errors;
      this.stock_groups = error ? [] : stock_groups;
      this.loading = false;
    },

    async execute() {
      try {
        this.loading = true;

        let {
          resident_id,
          origin_stock_group_id,
          origin_stocked_item_id,
          destination_stock_group_id,
          amount,
          medicine,
        } = this;

        let params = {
          resident_id,
          origin_stock_group_id,
          origin_stocked_item_id,
          destination_stock_group_id,
          amount,
          medicine,
        };

        const response = await api.post(
          "/rest-home/resident/stock/medicine-transfer",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.$bvModal.hide("transferMedicine");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
